import { CheckedInGuestVisit } from 'features/visitors/types';

import { GuestSearchResultItem } from '../types';

export const isGuestCheckedIn = (
  guestReservation: GuestSearchResultItem
): guestReservation is CheckedInGuestVisit =>
  Boolean((guestReservation as CheckedInGuestVisit).checkInTime);
